
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FeedbackFormValues } from './schema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

interface PositivesTabProps {
  form: UseFormReturn<FeedbackFormValues>;
}

const PositivesTab = ({ form }: PositivesTabProps) => {
  return (
    <FormField
      control={form.control}
      name="positives"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Points forts</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Décrivez les points forts du candidat..."
              className="resize-none min-h-[200px]"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PositivesTab;
